import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "user-profile" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexAvatars',
  setup(__props) {

const AvatarSize = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarSize.vue"))
const AvatarStatus = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarStatus.vue"))
const AvatarShapes = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarShapes.vue"))
const AvatarRatio = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarRatio.vue"))
const AvatarGrouping = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarGrouping.vue"))
const AvatarInitial = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarInitial.vue"))
const AvatarPing = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarPing.vue"))
const AvatarProfile = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarProfile.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Avatars",
      title: "Avatars"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(AvatarSize)),
          _createVNode(_unref(AvatarStatus)),
          _createVNode(_unref(AvatarShapes)),
          _createVNode(_unref(AvatarRatio)),
          _createVNode(_unref(AvatarGrouping)),
          _createVNode(_unref(AvatarInitial)),
          _createVNode(_unref(AvatarPing)),
          _createVNode(_unref(AvatarProfile))
        ])
      ])
    ])
  ], 64))
}
}

})